export const content_nb_NO_GF = {
  tacLabel:
    'Jeg samtykker til at Grønt Fokus kan samle inn og benytte seg av mine kontaktopplysninger i tråd med gjeldende GDPR.',
  tacError: 'Du må krysse i denne',
  submitButton: 'Send',
  imageAlt: 'Skjema-bilde',
  formNotFound: 'Vi fant dessverre ikke noe skjema',
  formNotStarted: 'Skjemaet er dessverre ikke tilgjengelig enda',
  formExpired: 'Skjemaet er dessverre ikke tilgjengelig',
  soonForwarded: 'Du vil snart bli videresendt til',
  loading: 'Laster skjema',
  posting: 'Poster svar',
  previewing: 'Forhåndsvisning av',
  errors: {
    'Forbidden - XSS warning':
      'Heisann! Gikk det litt raskt på tastaturet? Kontroller så det ikke snek seg inn uønskede tegn.',
    noFormUID: 'Skjema-ID savnes',
    noData: 'Skjemadata savnes eller er ugyldig',
  },
  contactLabels: {
    heading: 'Kontaktopplysninger',
    name: 'Fullt navn',
    address: 'Gateadresse',
    city: 'Poststed',
    postalCode: 'Postnummer',
    phone: 'Telefonnummer',
    email: 'E-post',
  },
  countryCode: '+47 ',
  errorMessages: {
    name: {
      tooLong: 'Navnet ditt har for mange tegn.',
    },
    address: {
      tooLong: 'Adressen din har for mange tegn.',
    },
    postalCode: {
      tooLong: 'Postnummeret ditt har for mange tegn.',
    },
    city: {
      tooLong: 'Poststedet ditt har for mange tegn.',
    },
    phone: {
      invalid: 'Vennligst skriv inn et riktig telefonnummer',
      tooShort: 'Telefonnummeret ditt inneholder for få tegn',
      tooLong: 'Telefonnummeret ditt har for mange tegn.',
    },
    email: {
      invalid: 'Vennligst skriv inn en gyldig e-post adresse',
      tooLong: 'E-post adressen din har for mange tegn.',
    },
  },
};
